import React, { useEffect, useState } from "react";
import calendarIcon from "../../../../../../Assets/images/calender.svg";
import { showErrorToast } from "../../../../../../Context/Toaster/Toaster";
import Loader from "../../../../../../Context/Loader/Loader";
import apiClient from "../../../../../../Config/apiClient";
import "../error.scss";
import { saveAs } from "file-saver";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DATE_MONTH_FORMAT } from "../../../Utils/Constants";

const summaryPath = process.env.REACT_APP_HS_SUMMARY_BASE_PATH;
const truckCompanyPath = process.env.REACT_APP_HS_TRUCK_COMPANY_BASE_PATH;

const TCInvoiceSummaryTab = () => {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [truckCompany, setTruckCompany] = useState("Any");
    const [invoiceStatus, setInvoiceStatus] = useState("Any");
    const [truckCompanies, setTruckCompanies] = useState([]);
    const [loading, setLoading] = useState(false);

    const [errors, setErrors] = useState({
        start: "",
        end: "",
        range: "",
    });

    const filenameFromDisposition = (cd) => {
        if (!cd) return null;
        const match = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        return match ? match[1].replace(/['"]/g, "") : null;
    };

    const fetchTruckCompanies = async () => {
        try {
            const response = await apiClient.get(`${truckCompanyPath}/`);
            if  (response.data && Array.isArray(response.data.data)) {
                setTruckCompanies(response.data.data);
            }else{
                setTruckCompanies([]);
            }
        } catch (error) {
            showErrorToast("Error fetching truck companies", error);
        }
    };

    useEffect(() => {
        fetchTruckCompanies();
    }, []);

    const validateDates = () => {
        let valid = true;
        let newErrors = { start: "", end: "", range: "" };

        if (!startDate) {
            newErrors.start = "Start date is required";
            valid = false;
        }
        if (!endDate) {
            newErrors.end = "End date is required";
            valid = false;
        }

        if (startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);

            if (start > end) {
                newErrors.start = "Start date cannot be after End date";
                valid = false;
            } else {
                const startMonth = start.getMonth();
                const startYear = start.getFullYear();
                const endMonth = end.getMonth();
                const endYear = end.getFullYear();

                const monthDiff = (endYear - startYear) * 12 + (endMonth - startMonth) + 1;
                if (monthDiff > 3) {
                    newErrors.range = "Report can only be generated for a maximum of 3 months";
                    valid = false;
                }
            }
        }

        setErrors(newErrors);
        return valid;
    };

    const handleGenerateReport = async () => {
        if (!validateDates()) return;

        try {
            setLoading(true);
            const payload = {
                startDate,
                endDate,
                truckCompany,
                invoiceStatus,
            };

            const response = await apiClient.post(`${summaryPath}/tc-invoice-summary`, payload, {
                responseType: "blob",
            });

            const cd = response.headers?.["content-disposition"] || response.headers?.get?.("content-disposition");
            const filename = filenameFromDisposition(cd) || "tc_invoice_summary.xlsx";
            saveAs(response.data, filename);
        } catch (error) {
            showErrorToast("No TC Invoice summary found for the selected options", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="report-tabinner">
            <div className="reportform-cover new-height mt-0">
                <div className="row">
                    <div className="col-md-6">
                        <div className="cp-split">
                            <label className="fi-label">Start date <span style={{ color: "red" }}>*</span></label>
                            <div className="datepicker-wrapper">
                                <DatePicker
                                    selected={startDate ? new Date(startDate) : null}
                                    onChange={(date) => { 
                                        setStartDate(date ? date.toLocaleDateString("en-CA") : ""); 
                                        setErrors({ ...errors, start: "", range: "" }); 
                                    }}
                                    placeholderText="Select start date"
                                    className={`custom-datetime-input common-input ${errors.start ? "error" : ""}`}
                                    dateFormat={DATE_MONTH_FORMAT}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    popperProps={{ strategy: 'fixed' }}
                                    autoComplete="off"
                                    portalId="root"
                                />
                                <img alt="Calendar" className="rpt-calendar-icon" src={calendarIcon} />
                            </div>
                            {errors.start && <div className="error-text active">{errors.start}</div>}
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="cp-split">
                            <label className="fi-label">End date <span style={{ color: "red" }}>*</span></label>
                            <div className="datepicker-wrapper">
                                <DatePicker
                                    selected={endDate ? new Date(endDate) : null}
                                    onChange={(date) => { 
                                        setEndDate(date ? date.toLocaleDateString("en-CA") : ""); 
                                        setErrors({ ...errors, end: "", range: "" }); 
                                    }}
                                    placeholderText="Select end date"
                                    className={`custom-datetime-input common-input ${errors.end || errors.range ? "error" : ""}`}
                                    dateFormat={DATE_MONTH_FORMAT}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    popperProps={{ strategy: 'fixed' }}
                                    autoComplete="off"
                                    portalId="root"
                                />
                                <img alt="Calendar" className="rpt-calendar-icon" src={calendarIcon} />
                            </div>
                            {errors.end && <div className="error-text active">{errors.end}</div>}
                            {errors.range && <div className="error-text active">{errors.range}</div>}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="cp-split">
                            <label className="fi-label">Truck Company</label>
                            <select className="common-select" value={truckCompany} onChange={(e) => setTruckCompany(e.target.value)}>
                                <option value="Any">Any</option>
                                {truckCompanies.map((company) => (
                                    <option key={company.id} value={company.id}>
                                        {company.company_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="cp-split">
                            <label className="fi-label">Invoice Status</label>
                            <select className="common-select" value={invoiceStatus} onChange={(e) => setInvoiceStatus(e.target.value)} >
                                <option value="Any">Any</option>
                                <option value="Pending">Pending</option>
                                <option value="Paid">Paid</option>
                            </select>
                        </div>
                    </div>
                </div>

                <button className="cp-button generate-button" type="button" onClick={handleGenerateReport} disabled={loading}>
                    {loading ? <Loader /> : "Generate Report"}
                </button>
            </div>
        </div>
    );
};

export default TCInvoiceSummaryTab;